import { Fragment } from 'react'
import { Flex, FormControl, FormLabel, Button, Stack } from '@chakra-ui/react'
import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import CustomFormQuestionOption from './components/CustomFormQuestionOption'
import CustomFormAdvancedOptionToSelect from './components/CustomFormAdvancedOptionToSelect'

export type CustomFormQuestionOptionsProps = {
  options: string[]
  type?: string
  formMethods: UseFormReturn<CustomFormQuestion>
}

export default function OptionsManagement({ options, type, formMethods }: CustomFormQuestionOptionsProps) {
  async function addOption() {
    const optionsArray = options
    optionsArray?.push(`Opção ${options.length + 1}`)
    formMethods.setValue('options', optionsArray)
  }

  async function addOptionOther() {
    const optionsArray = options
    optionsArray?.push('Outro')
    formMethods.setValue('options', optionsArray)
  }

  async function removeOptionOther() {
    const filteredOptions = options.filter((option) => option !== 'Outro')
    formMethods.setValue('options', filteredOptions)
  }

  return (
    <FormControl display="flex" flexDir="column">
      <Flex justifyContent="space-between">
        <FormLabel fontWeight="bold">Opções da questão</FormLabel>
        <CustomFormAdvancedOptionToSelect options={options} formMethods={formMethods} />
      </Flex>

      <Stack mt={2}>
        <Flex my={2} flexDir="column" gap={2}>
          {options?.map((option, index) => (
            <CustomFormQuestionOption
              key={option}
              options={options}
              formMethods={formMethods}
              type={type}
              index={index}
              option={option}
            />
          ))}
        </Flex>

        <Button variant="outline" onClick={addOption}>
          Adicionar opção
        </Button>

        {type !== 'SELECT' && (
          <Fragment>
            {options.includes('Outro') ? (
              <Button variant="ghost" colorScheme="red" onClick={removeOptionOther}>
                Remover campo {'Outro'}
              </Button>
            ) : (
              <Button variant="ghost" onClick={addOptionOther}>
                Adicionar campo {'Outro'}
              </Button>
            )}
          </Fragment>
        )}
      </Stack>
    </FormControl>
  )
}
